/**
 * Error handling utilities for API errors
 */

export interface ApiErrorResponse {
  detail: string;
  status_code?: number;
}

export interface ParsedError {
  code: string;
  message: string;
}

/**
 * Parse API error response and map to error codes
 */
export function parseApiError(error: any): ParsedError {
  // Network error
  if (!error.response && error.message === 'Failed to fetch') {
    return { code: 'networkError', message: error.message };
  }

  // Try to get error detail from response
  let errorDetail = '';

  if (error.detail) {
    errorDetail = error.detail;
  } else if (error.message) {
    errorDetail = error.message;
  }

  // Map common error messages to error codes
  const errorMessage = errorDetail.toLowerCase();

  // Duplicate email
  if (errorMessage.includes('email') &&
      (errorMessage.includes('already') || errorMessage.includes('exists') || errorMessage.includes('used'))) {
    return { code: 'duplicateEmail', message: errorDetail };
  }

  // Duplicate phone
  if (errorMessage.includes('phone') &&
      (errorMessage.includes('already') || errorMessage.includes('exists') || errorMessage.includes('used'))) {
    return { code: 'duplicatePhone', message: errorDetail };
  }

  // Validation errors
  if (errorMessage.includes('validation') || errorMessage.includes('invalid')) {
    return { code: 'invalidData', message: errorDetail };
  }

  // Server errors (5xx)
  if (error.status_code && error.status_code >= 500) {
    return { code: 'serverError', message: errorDetail };
  }

  // Default unknown error
  return { code: 'unknownError', message: errorDetail };
}
